import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { getOptionsFromValue, QueryResult } from '../../stores/dataStore';
import { DropdownProps, SelectionInput, SelectionItem } from '../form/selectionInput';
import { nameof } from '../../utils/object';
import { ItemReference } from '../../stores/dataStore';
import { isNullOrWhiteSpaces } from '../../utils/useful-functions';
import { ProfessionsStore, ProfessionDto } from 'stores/configuration/profiles/professions-store';

interface ProfessionEditorProps extends DropdownProps, WithTranslation {
  value: ItemReference;
  onChange: (value: ItemReference) => void;
  placeholder?: string;
  professions?: ProfessionsStore;
  nullable?: boolean;
  minWidth?: number;
  reloadOnChange?: boolean;
  className?: string;
  clearable?: boolean;
  readOnly?: boolean;
  loadDataOnOpen?: boolean;
}

interface ProfessionEditorState {
  value: ItemReference;
  query?: (searchQuery: string) => Promise<QueryResult<ItemReference>>;
  options: SelectionItem[];
}

@connect(['professions', ProfessionsStore])
class ProfessionEditor extends React.Component<ProfessionEditorProps, ProfessionEditorState> {
  private get professionsStore() {
    return this.props.professions;
  }

  constructor(props: ProfessionEditorProps) {
    super(props);
    this.state = {
      value: this.props.value,
      query: this.props.loadDataOnOpen ? null : this.getProfessionMethod(),
      options: getOptionsFromValue(this.state?.query, this.props.value)
    };
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (next !== this.props && next.value !== this.props.value && this.props.reloadOnChange) {
      this.setState({
        value: next.value,
        query: this.getProfessionMethod()
      });
    }
  }

  @autobind
  private getProfessionMethod() {
    const method = async (search: string) => {
      const result = await this.professionsStore.getAllAsync({
        searchQuery: '',
        skip: 0,
        take: 100000,
        orderBy: [{ direction: 'Ascending', field: nameof<ProfessionDto>('profession'), useProfile: false }],
        filter: isNullOrWhiteSpaces(search)
          ? []
          : [`startswith(tolower(${nameof<ProfessionDto>('profession')}), '${search.toLowerCase()}')`]
      });
      return Object.assign({}, result, { items: result.items.map(c => ({ id: c.id, title: c.profession })) }) as QueryResult<ItemReference>;
    };
    return method;
  }
  onOpenDropDown = () => {
    if (this.props.loadDataOnOpen && !this.state.query) {
      this.setState({ query: this.getProfessionMethod() });
    }
  };

  public render() {
    const val = this.state.value;
    const options = this.state.options;
    const query = this.state.query;
    return (
      <SelectionInput
        content={item => <>{item.title}</>}
        searchable
        minWidth={this.props.minWidth}
        nullable={this.props.nullable}
        placeholder={this.props.placeholder}
        query={query}
        value={val}
        onChange={value => this.props.onChange(value as any)}
        className={this.props.className}
        clearable={this.props.clearable}
        readOnly={this.props.readOnly}
        onOpenDropDown={this.onOpenDropDown}
        options={this.state.query != null ? null : options}
        onBlur={e => this.props.onBlur && this.props.onBlur(e)}
        onFocus={e => this.props.onFocus && this.props.onFocus(e)}
      />
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(ProfessionEditor);
